import axios from "axios";

const BACKEND_URL = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
export const API = BACKEND_URL ? `${BACKEND_URL}/api` : "/api";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function fileUrl(pathOrUrl) {
  if (!pathOrUrl) return "";
  if (pathOrUrl.startsWith("http")) return pathOrUrl;
  if (pathOrUrl.startsWith("/api/")) return BACKEND_URL ? `${BACKEND_URL}${pathOrUrl}` : pathOrUrl;
  return pathOrUrl;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const rupee = (n) => `₹${Number(n || 0).toLocaleString("en-IN")}`;

/** Same rules as backend helpers.slugify */
export function slugify(text) {
  return String(text || "")
    .toLowerCase()
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-")
    .slice(0, 80) || "product";
}

/** SEO product page path — never prefer bare UUID when name is available */
export function productPath(p) {
  if (!p) return "/shop";
  if (p.slug) return `/product/${p.slug}`;
  const computed = slugify(p.code ? `${p.name}-${p.code}` : p.name);
  if (computed && computed !== "product") return `/product/${computed}`;
  return `/product/${p.id}`;
}
